import './index.scss'

class Video {
    constructor(el) {
        this.$el = el
    }
    init() {
        this.poster = this.$el.querySelector('.acf-video__poster')
        this.button = this.$el.querySelector('.acf-video__button')
        this.video = this.$el.querySelector('.acf-video__media')
        this.$el.classList.add('anim');
        this.button.addEventListener('click', () => {
            this.video.src = this.video.dataset.src
            this.poster.classList.add('hide')
            this.video.addEventListener('canplaythrough', () => this.video.play(), {capture: false, passive: true, once: true} || false)
            this.video.play()
        }, {capture: false, passive: true, once: true} || false)
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-video') ].forEach($block => {
        $block.expandygg = new Video($block)
    })
}, {capture: false, passive: true, once: true} || false)